var _rect, _title, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 32 32",
    height: 24,
    width: 30,
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    fill: "#484848",
    className: "selected",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "m28,4 h-26 c-1.1045,0 -2,-0.8955000000000001 -2,-2 s0.8955000000000001,-2 2,-2 h26 c1.1045,0 2,0.8955000000000001 2,2 s-0.8955000000000001,2 -2,2 z",
    id: "svg_1",
    fill: "#484848",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28,24 h-26 c-1.1045,0 -2,-0.8955000000000001 -2,-2 s0.8955000000000001,-2 2,-2 h26 c1.1045,0 2,0.8955000000000001 2,2 s-0.8955000000000001,2 -2,2 z",
    id: "svg_2",
    fill: "#484848",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28,14 h-26 c-1.1045,0 -2,-0.8955000000000001 -2,-2 s0.8955000000000001,-2 2,-2 h26 c1.1045,0 2,0.8955000000000001 2,2 s-0.8955000000000001,2 -2,2 z",
    id: "svg_3",
    fill: "#484848",
    fillOpacity: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.6a57b9df2158d90bae118a0060f5f96f.svg";
export { ForwardRef as ReactComponent };